<template>
  <span class="status-chip" :style="chipStyle">
    <span v-if="dot" class="status-chip-dot" :style="{ background: color }"></span>
    <slot>{{ label }}</slot>
  </span>
</template>

<script>
export default {
  name: "StatusChip",
  props: {
    label: { type: String, default: "" },
    color: { type: String, default: "#1565C0" },
    // 'solid' filled bg, 'soft' tinted bg, 'dot' just a colored dot + text
    variant: { type: String, default: "soft" },
  },
  computed: {
    dot() {
      return this.variant === "dot";
    },
    chipStyle() {
      if (this.variant === "solid") {
        return { background: this.color, color: "#fff", border: "none" };
      }
      if (this.variant === "dot") {
        return { background: "transparent", color: "#455A64", border: "none", padding: "0" };
      }
      // soft
      return {
        background: this.hexToRgba(this.color, 0.12),
        color: this.color,
        border: "none",
      };
    },
  },
  methods: {
    hexToRgba(hex, alpha) {
      let h = hex.replace("#", "");
      if (h.length === 3) h = h.split("").map((c) => c + c).join("");
      const r = parseInt(h.substring(0, 2), 16);
      const g = parseInt(h.substring(2, 4), 16);
      const b = parseInt(h.substring(4, 6), 16);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
  },
};
</script>

<style scoped>
.status-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
}

.status-chip-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
</style>
